export default __webpack_public_path__ + "static/media/slider2.dcc9f0eb.jpg";